var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBroadcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.211 9.107 7.737 5.869A1.2 1.2 0 0 0 6 6.943v6.116a1.2 1.2 0 0 0 1.737 1.074l6.474-3.238a.999.999 0 0 0 0-1.788"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
})));
export default SvgBroadcast;